/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-11-25 13:50:26
 * @LastEditors: shenlin
 * @LastEditTime: 2021-11-26 13:26:07
 */
const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'
// 走访管理-走访记录列表查询
export const listByPage = params => request(BASE_URL + '/visitManage/listByPage', { params })
// 走访管理-走访详情
export const getDetailById = params => request(BASE_URL + '/visitManage/getDetailById', { params })
// 走访管理-走访进度详情
export const getProcessById = params => request(BASE_URL + '/visitManage/getProcessById', { params })
// 走访记录-上传图片
export const addEntData = process.env.VUE_APP_BASE_API + BASE_URL + '/api/file/saveFileByContentType'
// 走访管理-专员接受邀请或拒绝邀请或上传记录副本
export const dealVisitRecord = data => request.post(BASE_URL + '/visitManage/dealVisitRecord', data)
// 走访管理-获取可选企业列表
export const getCommissionerManagerList = params => request(BASE_URL + '/visitManage/getCommissionerManagerList', { params })
// 走访管理-专员发起邀请
export const addVisitRecordInfo = params => request.post(BASE_URL + '/visitManage/addVisitRecordInfo',  params )
